export const getAuthToken = () => {
  try {
    const raw = window.localStorage.getItem('token');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return typeof parsed === 'string' ? parsed : null;
  } catch {
    return null;
  }
};
